import SjPlyrVideoBox from './src/main.js'

export default SjPlyrVideoBox



// WEBPACK FOOTER //
// ./core/components/sj-plyr-video-box/index.js